import { NBMap as Map } from './map'
import * as MaplibreGL from 'maplibre-gl'
import {
  DirectionsService,
  DistanceMatrixService,
  SnapToRoadsService,
  NavigationService,
  OptimizationMvrpService,
  OptimizationMvrpServiceV2,
} from './api/index'

export default {
  ...MaplibreGL,
  NavigationService,
  OptimizationMvrpService,
  OptimizationMvrpServiceV2,
  DirectionsService,
  DistanceMatrixService,
  SnapToRoadsService,
  Map,
}
